import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Spot } from './spotsTypes';

export const initialState: SpotsState = {
  map: {}
};

export interface SpotsState {
  map: Record<string, Spot | undefined>;
}

const spotsSlice = createSlice({
  name: 'spots',
  initialState,
  reducers: {
    updateSpot(state, action: PayloadAction<Partial<Spot>>) {
      const { id } = action.payload;

      if (!id) {
        return;
      }

      state.map[id] = { ...state.map[id], ...action.payload };
    }
  }
});

export const spotsReducer = spotsSlice.reducer;

export const { updateSpot } = spotsSlice.actions;
